const phoiDefault = {
  hoTenTop: 134,
  hoTenLeft: 280,
  ngaySinhTop: 160,
  ngaySinhLeft: 280,
  noiSinhTop: 186,
  noiSinhLeft: 280,
  gioiTinhTop: 212,
  gioiTinhLeft: 200,
  danTocTop: 212,
  danTocLeft: 400,
  donViDangKyDuThiTop: 238,
  donViDangKyDuThiLeft: 280,
  namTop: 264,
  namLeft: 280,
  xepLoaiTop: 290,
  xepLoaiLeft: 250,
  hinhThucDaoTaoTop: 290,
  hinhThucDaoTaoLeft: 550,
  donVi1Top: 318,
  donVi1Left: 418,
  ngayTaoDateTop: 318,
  ngayTaoDateLeft: 538,
  ngayTaoMonthTop: 318,
  ngayTaoMonthLeft: 612,
  ngayTaoYearTop: 318,
  ngayTaoYearLeft: 673,
  donVi2Top: 376,
  donVi2Left: 550,
  soVaoSoTop: 478,
  soVaoSoLeft: 260,
}

export { phoiDefault }
